// Secondary accessory: gold hoop earrings.
// Used for La Clica feminine archetypes (Doña Tamales, La Jefa, La Frutera).
// Pair of overlapping hoops — large, gold, reads from a block away.

interface HoopEarringsProps {
  /** Hoop color (gold). */
  bodyColor?: string;
  /** Highlight color (chrome inner accent). */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function HoopEarrings({
  bodyColor = '#d4a945',
  accentColor = '#f5ecd6',
  size = 48,
  className,
}: HoopEarringsProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Left hoop — large, anchored top */}
      <circle cx="16" cy="28" r="13" fill="none" stroke={bodyColor} strokeWidth="3.5" />
      {/* Left hoop highlight */}
      <path
        d="M6 22 Q4 28 6 34"
        stroke={accentColor}
        strokeWidth="1.5"
        fill="none"
        opacity="0.7"
      />
      {/* Left earlobe attachment */}
      <circle cx="16" cy="14" r="1.5" fill={bodyColor} />
      {/* Right hoop — slightly larger, offset (overlap creates depth) */}
      <circle cx="34" cy="30" r="14" fill="none" stroke={bodyColor} strokeWidth="3.5" />
      {/* Right hoop highlight */}
      <path
        d="M44 24 Q46 30 44 36"
        stroke={accentColor}
        strokeWidth="1.5"
        fill="none"
        opacity="0.7"
      />
      {/* Right earlobe attachment */}
      <circle cx="34" cy="15" r="1.5" fill={bodyColor} />
    </svg>
  );
}
